"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Close = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var icons_1 = require("../../icons");
var Close = function (_a) {
    var large = _a.large, onClick = _a.onClick;
    var Icon = large ? icons_1.Remove48 : icons_1.Remove32;
    return ((0, jsx_runtime_1.jsx)("button", __assign({ type: "button", onClick: onClick, className: "btn-close-inline", "aria-label": "Close" }, { children: (0, jsx_runtime_1.jsx)("span", __assign({ "aria-hidden": "true" }, { children: (0, jsx_runtime_1.jsx)(Icon, {}) })) })));
};
exports.Close = Close;
